/**
 * @generated SignedSource<<e3576df1615fbdb0f69d470e714bde22>>
 * @relayHash 72f5ef23ae3077c9f6d28a4dbe7d4afe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67ee6270fe993ecb73a504945ebe049f1aafd884133ff96f5714c88c6a006525

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraBoardViewInput = {
  jiraBoardViewQueryInput: JiraBoardViewQueryInput;
  settings?: JiraBoardViewSettings | null | undefined;
};
export type JiraBoardViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraBoardViewProjectKeyAndItemIdQuery | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraBoardViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraBoardViewSettings = {
  filterJql?: string | null | undefined;
  groupBy?: string | null | undefined;
};
export type CardActionsMenuContentQuery$variables = {
  cloudId: string;
  projectAri: string;
  viewInput: JiraBoardViewInput;
  withCardCoverAlwaysOn: boolean;
};
export type CardActionsMenuContentQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly canCreateIssues: {
        readonly canPerform: boolean;
      };
      readonly canDeleteIssues: {
        readonly canPerform: boolean;
      };
      readonly canEditIssues: {
        readonly canPerform: boolean;
      };
      readonly canLinkIssues: {
        readonly canPerform: boolean;
      };
      readonly canScheduleIssues: {
        readonly canPerform: boolean;
      };
    };
  };
  readonly jira_boardView: {
    readonly cardOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly field?: {
            readonly fieldId: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
  };
  readonly jira_categoryField: {
    readonly fieldId: string;
  } | null | undefined;
};
export type CardActionsMenuContentQuery = {
  response: CardActionsMenuContentQuery$data;
  variables: CardActionsMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withCardCoverAlwaysOn"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "viewInput"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "kind": "Literal",
    "name": "enabledOnly",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v9 = [
  (v5/*: any*/)
],
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "CREATE_ISSUES"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "canPerform"
},
v13 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "DELETE_ISSUES"
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EDIT_ISSUES"
  }
],
v15 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "LINK_ISSUES"
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "SCHEDULE_ISSUES"
  }
],
v17 = [
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CardActionsMenuContentQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "jira_categoryField",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v5/*: any*/),
            "action": "THROW",
            "path": "jira_categoryField.fieldId"
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v6/*: any*/),
          "concreteType": "JiraBoardView",
          "kind": "LinkedField",
          "name": "jira_boardView",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v7/*: any*/),
              "action": "THROW",
              "path": "jira_boardView.id"
            },
            {
              "condition": "withCardCoverAlwaysOn",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": (v8/*: any*/),
                  "concreteType": "JiraBoardViewCardOptionConnection",
                  "kind": "LinkedField",
                  "name": "cardOptions",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraBoardViewCardOptionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraField",
                                  "kind": "LinkedField",
                                  "name": "field",
                                  "plural": false,
                                  "selections": (v9/*: any*/)
                                }
                              ],
                              "type": "JiraBoardViewFieldCardOption"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "storageKey": "cardOptions(enabledOnly:true,first:100)"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira_boardView"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v10/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canCreateIssues",
                      "args": (v11/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v12/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canCreateIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"CREATE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canCreateIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canDeleteIssues",
                      "args": (v13/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v12/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canDeleteIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"DELETE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canDeleteIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canEditIssues",
                      "args": (v14/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v12/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canEditIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"EDIT_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canEditIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canLinkIssues",
                      "args": (v15/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v12/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canLinkIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"LINK_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canLinkIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canScheduleIssues",
                      "args": (v16/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v12/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canScheduleIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canScheduleIssues"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProject"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CardActionsMenuContentQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "jira_categoryField",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      {
        "args": (v6/*: any*/),
        "concreteType": "JiraBoardView",
        "kind": "LinkedField",
        "name": "jira_boardView",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "condition": "withCardCoverAlwaysOn",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraBoardViewCardOptionConnection",
                "kind": "LinkedField",
                "name": "cardOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraBoardViewCardOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraBoardViewFieldCardOption"
                          },
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "cardOptions(enabledOnly:true,first:100)"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              {
                "alias": "canCreateIssues",
                "args": (v11/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": "action(type:\"CREATE_ISSUES\")"
              },
              {
                "alias": "canDeleteIssues",
                "args": (v13/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": "action(type:\"DELETE_ISSUES\")"
              },
              {
                "alias": "canEditIssues",
                "args": (v14/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": "action(type:\"EDIT_ISSUES\")"
              },
              {
                "alias": "canLinkIssues",
                "args": (v15/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": "action(type:\"LINK_ISSUES\")"
              },
              {
                "alias": "canScheduleIssues",
                "args": (v16/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "67ee6270fe993ecb73a504945ebe049f1aafd884133ff96f5714c88c6a006525",
    "metadata": {},
    "name": "CardActionsMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "41bef48b534c96802cfa7560bc373cd2";

export default node;
